export const noop = (functionName, ...args) => {
	const log = console.debug || console.info || console.log;

	log(`Function "${functionName}" was called but not implemented`, args);
};
